import SubscriptionsModule, {
  SubscriptionsModuleProps,
} from './SubscriptionsModule';

export type {SubscriptionsModuleProps};
export default SubscriptionsModule;
